export default __webpack_public_path__ + "static/media/grafana.948954dd.svg";